module.exports = __webpack_public_path__ + "img/2-4.512e2e69.svg";